<div class="scores-main">
  <div class="scores-list">
    <div class="scores-list-header">
      <div class="scores-list-title">
        <span class="brand-dot"></span>ScoreAI
      </div>
      <div class="scores-list-info">
        Use Yukka’s Score AI tool to build specific signals tailored to your
        needs or make use of our pre-built signals.
      </div>
    </div>
    <div class="scores-list-container">
      <div class="list-container-contents">
        <!-- One row shape for both lists: built-in scores and custom ones
             differ only in where uid/label come from. -->
        <ng-template
          #scoreRow
          let-uid="uid"
          let-label="label"
          let-rowClass="rowClass"
        >
          <div
            class="option"
            [ngClass]="rowClass"
            role="button"
            tabindex="0"
            [class.active]="
              featureFlagsService.scorelabSettings.defaultScore === uid
            "
            (click)="selectScore(uid)"
            (keydown.enter)="selectScore(uid)"
            (keydown.space)="$event.preventDefault(); selectScore(uid)"
          >
            <span class="mark">
              <mat-icon
                *ngIf="
                  featureFlagsService.scorelabSettings.defaultScore === uid
                "
                >check</mat-icon
              >
            </span>
            <div class="score" [class.current]="currentScore.uid === uid">
              {{ label }}
            </div>
          </div>
        </ng-template>

        <div class="yukka-scores" *ngIf="visibleYukkaScores.length">
          <div class="title">Yukka Scores</div>
          <ng-container *ngFor="let score of visibleYukkaScores">
            <ng-container
              *ngTemplateOutlet="scoreRow; context: score"
            ></ng-container>
          </ng-container>
        </div>
        <div
          class="custom-scores"
          *ngIf="featureFlagsService.scorelabSettings.customScoreAccess"
        >
          <div class="title">My Custom Scores</div>
          <ng-container *ngFor="let score of customScores">
            <ng-container
              *ngTemplateOutlet="
                scoreRow;
                context: {
                  uid: score.uid,
                  label: score.name,
                  rowClass: 'option-custom-score',
                }
              "
            ></ng-container>
          </ng-container>
        </div>
      </div>
      <div class="list-container-actions">
        <div
          id="create-custom-score"
          class="option"
          (click)="createScore()"
          (keydown.enter)="createScore()"
          (keydown.space)="$event.preventDefault(); createScore()"
          role="button"
          tabindex="0"
          *ngIf="featureFlagsService.scorelabSettings.customScoreAccess"
        >
          <mat-icon>add_circle_outline</mat-icon>
          <div class="score" [class.current]="currentScoreType === 'new'">
            Create Score
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="scores-settings">
    <div class="scores-settings-header">
      <div class="scores-settings-title">
        <div class="title-contents">
          <div class="title-dyn" *ngIf="currentScoreType === 'yukka'">
            {{ currentScore.name }}
          </div>
          <div
            class="title-dyn"
            *ngIf="currentScoreType !== 'yukka'"
            [class.notitle]="notitle"
          >
            <input
              matInput
              placeholder="Create score's name *"
              required
              [(ngModel)]="currentScore.name"
            />
          </div>
        </div>
        <div class="title-actions">
          <button
            class="set-default-btn pendo-set-default-score"
            [ngClass]="setDefaultHook"
            mat-flat-button
            color="primary"
            *ngIf="
              currentScoreType !== 'new' &&
              currentScore.uid &&
              featureFlagsService.scorelabSettings.defaultScore !==
                currentScore.uid
            "
            (click)="setAsDefault(currentScore.uid)"
          >
            <mat-icon>flag</mat-icon>Set as default
          </button>
          <span
            class="default-badge"
            *ngIf="
              currentScore.uid &&
              featureFlagsService.scorelabSettings.defaultScore ===
                currentScore.uid
            "
            ><mat-icon>check_circle</mat-icon>Default score</span
          >
          <mat-icon
            class="close-icon pendo-score-dialog-close"
            matTooltip="Close"
            matTooltipPosition="below"
            aria-label="Close"
            aria-hidden="false"
            role="button"
            tabindex="0"
            (click)="iClose()"
            (keydown.enter)="iClose()"
            (keydown.space)="$event.preventDefault(); iClose()"
            >close</mat-icon
          >
        </div>
      </div>
    </div>
    <div class="scores-settings-container">
      <div
        class="settings-container-contents info"
        *ngIf="currentScoreType === 'yukka'"
      >
        <div class="score-lock">
          <mat-icon>lock</mat-icon>Proprietary YUKKA Lab score · not editable
        </div>
        <p *ngFor="let paragraph of currentYukkaScore?.description">
          {{ paragraph }}
        </p>
        <div class="score-scale" *ngIf="scoreScale">
          <div class="scale-head">
            <span>Score range</span>
            <span>{{ scoreScale.min }} – {{ scoreScale.max }}</span>
          </div>
          <div class="scale-bar"></div>
          <div class="scale-ends">
            <span>
              <b>{{ scoreScale.min }}</b> · {{ scoreScale.lo }}
            </span>
            <span>
              {{ scoreScale.hi }} · <b>{{ scoreScale.max }}</b>
            </span>
          </div>
        </div>
      </div>
      <div
        class="settings-container-contents"
        *ngIf="currentScoreType !== 'yukka'"
      >
        <div class="table-header">
          <div class="table-row">
            <div class="table-item">
              <div class="box-value">Event</div>
            </div>
            <div class="table-values">
              <div
                class="box-value"
                matTooltip="Select the importance of the event where 5 is very important."
                matTooltipPosition="above"
              >
                Importance
              </div>
              <div
                class="box-value"
                matTooltip="Select the type of impact this event has on you. Choose between positive and negative."
                matTooltipPosition="above"
              >
                Impact
              </div>
            </div>
            <div class="table-actions"></div>
          </div>
        </div>

        <div class="table-contents" #eventsContainer>
          <div
            class="table-row"
            *ngFor="let event of currentScore.event_weights; index as index"
          >
            <div class="table-item">
              <div
                class="box-value"
                [class.invalid]="event.event_id === undefined"
              >
                <form [formGroup]="eventsForms[index]">
                  <mat-icon class="lead-icon">search</mat-icon>
                  <input
                    #inputScoreEvent
                    type="text"
                    class="event-input"
                    required
                    placeholder="Click to scroll or type…"
                    formControlName="eventsFormGroup"
                    [matAutocomplete]="eventsAutocomplete"
                  />
                  <mat-autocomplete #eventsAutocomplete="matAutocomplete">
                    <mat-optgroup
                      *ngFor="
                        let group of eventsGroupsFiltered$[index]
                          | async
                          | orderBy: 'label'
                      "
                      [label]="group.label"
                    >
                      <mat-option
                        *ngFor="let eventName of group.events | orderBy"
                        [value]="eventName"
                      >
                        {{ eventName }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-autocomplete>
                </form>
              </div>
            </div>
            <div class="table-values">
              <div class="box-value weight">
                <mat-select
                  [(ngModel)]="currentScore.event_weights[index].weight"
                >
                  <mat-option
                    *ngFor="let weight of weightOptions"
                    [value]="weight"
                    >{{ weight }}</mat-option
                  >
                </mat-select>
              </div>
              <div class="box-value polarity">
                <mat-select
                  [(ngModel)]="currentScore.event_weights[index].polarity"
                >
                  <mat-option
                    *ngFor="let polarity of polarityOptions"
                    [value]="polarity.value"
                    >{{ polarity.label }}</mat-option
                  >
                </mat-select>
              </div>
            </div>
            <div class="table-actions">
              <mat-icon
                matTooltip="Remove Event"
                matTooltipPosition="above"
                aria-label="Remove event"
                aria-hidden="false"
                role="button"
                tabindex="0"
                (click)="removeEvent(index)"
                (keydown.enter)="removeEvent(index)"
                (keydown.space)="$event.preventDefault(); removeEvent(index)"
                >close</mat-icon
              >
            </div>
          </div>
          <div class="table-row last">
            <button mat-button (click)="addEvent()">
              <mat-icon>add_circle_outline</mat-icon>
              <span>ADD EVENT</span>
            </button>
          </div>
        </div>
      </div>
      <!--<div class="settings-container-actions" *ngIf="currentScoreType !== 'yukka'"></div>-->
    </div>
    <div class="scores-settings-footer">
      <button
        class="delete"
        mat-button
        *ngIf="this.currentScoreType === 'custom'"
        (click)="deleteScore()"
        [class.delete-warning]="isButtonActive"
        (mouseover)="isButtonActive = true"
        (mouseout)="isButtonActive = false"
      >
        <mat-icon>delete</mat-icon>
        <span>DELETE</span>
      </button>
      <button
        class="save"
        mat-button
        *ngIf="this.currentScoreType !== 'yukka'"
        (click)="saveScore()"
      >
        <mat-icon>save</mat-icon>
        <span>SAVE</span>
      </button>
    </div>
  </div>
</div>
